module.exports = __webpack_public_path__ + "static/media/Premium-Education-Centre.2faf162f.png";